import Config from '@config';
import { initializeMeteringDeviceApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  meteringDevicesApi,
  useGetMeteringDevicesQuery,
  useGetMeteringDeviceByIdQuery,
  useCreateMeteringDeviceMutation,
  useUpdateMeteringDeviceByIdMutation,
  useDeleteMeteringDeviceByIdMutation,
  useGetMeteringDevicesInfiniteQuery,
  useGetMeteringDeviceByIdStatusHistoryInfiniteQuery,
  useGetSealCreationMeteringDevicesInfiniteQuery,
  useGetCachedDevicesByIdSelector,
} = initializeMeteringDeviceApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});
